import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from "react-query";
import { UserContextProvider } from './context/userContext';



const root = ReactDOM.createRoot(document.getElementById('root'));
const client = new QueryClient()
root.render( 
<React.StrictMode >
  <UserContextProvider>
  <QueryClientProvider client={client}>
    <App />
  </QueryClientProvider>
  </UserContextProvider>
</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
